import {MessageBase} from './message-base';

export class MessageLastDate extends MessageBase<MessageLastDate> {
  private lastDate: Date;

  constructor(lastDate: Date) {
    super(MessageLastDate);

    this.lastDate = lastDate;
  }

  public get LastDate(): Date {
    return this.lastDate;
  }
}
